module.exports = {"baseQuery":"1=1","overheadQuery":"resourceKind = 'Overhead'","equipQuery":"resourceKind = 'Equipment'","aircraftQuery":"resourceKind = 'Aircraft'","crewsQuery":"resourceKind = 'Crews'","groupsQuery":"resourceKind = 'Team' OR resourceKind = 'Module' OR resourceKind = 'Overhead Group' OR resourceKind = 'Equipment Group' OR resourceKind = 'Aircraft Group'","currentDispatchID":"","defaultSort":[{"id":"ModifiedOnDateTime","desc":true}],"fields":[]}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/datagrids/resources.json
// module id = 195
// module chunks = 0